/**
 * Court layer: Alameda County Superior Court. See src/courts/index.js for the shape.
 *
 * The only Alameda material in data/ is the court's forms pages, so this entry holds its
 * local forms and nothing else. Departments, local rules, e-filing, hearing reservation and
 * holidays fall back to "verify" items, and dates use the statewide judicial holidays.
 */
export default {
  id: "alameda-superior",

  details: {
    forms: {
      coverSheetAddendum: {
        text: "File the Civil Case Cover Sheet Addendum (Form 202-19) with every new unlimited civil case. It picks the courthouse (Hayward, Oakland or Pleasanton) and Alameda's own case type.",
        cite: "Alameda Form 202-19",
        forms: ["ca-ala-202-19"],
        value: { classes: ["unlimited"] },
      },
      defaultDeficiency: {
        text: "In a default judgment for a deficiency after an auto sale or lease, complete Alameda's Deficiency Memorandum for Default Judgment (AC-014): contract, repossession, resale and deficiency calculations, with the proof it lists.",
        cite: "Alameda Form AC-014",
        forms: ["ca-ala-ac-014"],
      },
    },
    rules: {
      adrPackage: {
        text: "The plaintiff must include the court's ADR Information Packet with the complaint when serving each defendant. A cross-complainant serves it on any new party.",
        cite: "Alameda ADR Information Packet",
        forms: ["ca-ala-adr-packet"],
      },
      adrStipulation: {
        text: "Parties who want early ADR can delay the initial case management conference by filing form ALA ADR-001, Stipulation to Attend ADR and Delay Initial Case Management Conference for 90 Days (also printed in the ADR Information Packet), with the CM-110.",
        cite: "Alameda Form ALA ADR-001; CRC 3.221(a)(4)",
        forms: ["ca-ala-adr-001"],
      },
    },
  },
};
